"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDetailEventActions = exports.EventTypes = void 0;
var EventTypes;
(function (EventTypes) {
    EventTypes["ProductDetailEvent"] = "ProductDetailEvent";
    EventTypes["ProductDetailCABDIVEvent"] = "ProductDetailCABDIVEvent";
    EventTypes["ProductDetailCABNTLEvent"] = "ProductDetailCABNTLEvent";
    EventTypes["PIMProductDetailCABDIVEvent"] = "PIMProductDetailCABDIVEvent";
    EventTypes["PIMProductDetailCABNTLEvent"] = "PIMProductDetailCABNTLEvent";
    EventTypes["ProductWorksWellWith"] = "WorksWellWith";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
var ProductDetailEventActions;
(function (ProductDetailEventActions) {
    ProductDetailEventActions["ProductDetailCreated"] = "ProductDetailCreated";
    ProductDetailEventActions["ProductDetailUpdated"] = "ProductDetailUpdated";
    ProductDetailEventActions["ProductDetailDeleted"] = "ProductDetailDeleted";
    ProductDetailEventActions["CreateProductDetail"] = "CreateProductDetail";
    ProductDetailEventActions["UpdateProductDetail"] = "UpdateProductDetail";
    ProductDetailEventActions["DeleteProductDetail"] = "DeleteProductDetail";
    ProductDetailEventActions["WorksWellWithUpdated"] = "WorksWellWithUpdated";
})(ProductDetailEventActions = exports.ProductDetailEventActions || (exports.ProductDetailEventActions = {}));
